
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Validation from "@/components/Validation.vue";
import { Validations } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import { ITenstarSimulatorStudent } from "@/interfaces/ITenstarSimulatorStudent";
import SaveButton from "@/components/Button/SaveButton.vue";
import AbortButton from "@/components/Button/AbortButton.vue";
import EditButton from "@/components/Button/EditButton.vue";

@Component({
  components: {
    EditButton,
    AbortButton,
    SaveButton,
    Validation,
  },
})
export default class SimulatorForm extends Vue {
  @Prop({ required: true }) readonly formData!: ITenstarSimulatorStudent;
  @Prop({ type: Boolean, default: true }) readonly studentIsOnSimulator!: boolean;

  @Validations()
  public validations() {
    return {
      form: {
        firstName: { required },
        lastName: { required },
        email: { required, email },
      },
    };
  }

  public form: ITenstarSimulatorStudent = {
    firstName: "",
    lastName: "",
    email: "",
  };

  public isEditForm = false;

  private resetFormData() {
    this.form = { ...this.formData };
  }

  public cancelEdit() {
    this.resetFormData();

    if (this.studentIsOnSimulator) {
      this.isEditForm = false;
    }
  }

  public onSubmit() {
    this.$v.$touch();

    if (this.$v.$invalid) {
      return;
    }

    const eventName = this.studentIsOnSimulator ? "update" : "save";
    this.$emit(eventName, this.form);

    this.isEditForm = false;
  }

  @Watch("formData", { deep: true })
  onFormDataChanged(): void {
    this.resetFormData();
  }

  public mounted() {
    this.resetFormData();
    this.isEditForm = !this.studentIsOnSimulator;
  }
}
